import { render, staticRenderFns } from "./ProductTileSkeleton.vue?vue&type=template&id=9557641e&lang=pug&"
import script from "./ProductTileSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductTileSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProductTileSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9557641e')) {
      api.createRecord('9557641e', component.options)
    } else {
      api.reload('9557641e', component.options)
    }
    module.hot.accept("./ProductTileSkeleton.vue?vue&type=template&id=9557641e&lang=pug&", function () {
      api.rerender('9557641e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductTileSkeleton.vue"
export default component.exports